import { ObservableArray, View } from "binder"
import { DistrictSaleDebtorsAndCreditorsViewModel, singleLine } from "./districtSaleDebtorsAndCreditors-viewModel"

export class DistrictSaleDebtorsAndCreditorsView extends View<DistrictSaleDebtorsAndCreditorsViewModel>{
    GetViewUniqueId(): string {
        return "V-9A0AFAAA-8365-4FED-AC14-ED367EC9A0FB"
    }
    loadHtml(): string {
        let element = require('./districtSaleDebtorsAndCreditors.html').default;
        let style = require('./districtSaleDebtorsAndCreditors.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set items(v: ObservableArray<singleLine>) { this._items = v; } public get items(): ObservableArray<singleLine> { return this._items;} private _items: ObservableArray<singleLine>;
    
    refresh(){
        this.dataContext.refresh();
    }
}
